exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".secureFrame {\n  border: none;\n  margin: auto 0px;\n}\n\n#secureFrameWrapper {\n  width: 470px;\n  overflow: hidden;\n  margin: 0px auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/payment/paymenttech-form/paymenttech-form-popup/paymenttech-form-popup.component.css
// module id = ../../../../../src/app/components/payment/paymenttech-form/paymenttech-form-popup/paymenttech-form-popup.component.css
// module chunks = main